import InspectionLogForm from "../components/InspectionLogForm";
import Menu from "../components/Menu";
const InspetionLogFormPage = () => {
  return (
    <>
      <Menu />
      <InspectionLogForm />
    </>
  );
}

export default InspetionLogFormPage;
